import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMail, FiArrowRight, FiCheckCircle } from 'react-icons/fi';
import api from '../../utils/api';
import './AuthPages.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בשליחת קישור האיפוס');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Left Side - Form */}
        <motion.div
          className="auth-form-section"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <div className="auth-form-content">
            <Link to="/" className="logo">
              <span className="logo-ai">AI</span>
              <span className="logo-weon">weOn</span>
            </Link>

            {!submitted ? (
              <>
                <h1>שחזור סיסמה</h1>
                <p className="auth-subtitle">
                  הזן את כתובת האימייל שלך ונשלח לך קישור לאיפוס הסיסמה
                </p>

                <form onSubmit={handleSubmit} className="auth-form">
                  <div className="form-group">
                    <label className="form-label">אימייל</label>
                    <div className="input-with-icon">
                      <FiMail className="input-icon" />
                      <input
                        type="email"
                        placeholder="your@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="form-input"
                      />
                    </div>
                  </div>

                  {error && <span className="form-error">{error}</span>}

                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    disabled={isLoading}
                  >
                    {isLoading ? 'שולח...' : 'שלח קישור לאיפוס'}
                  </button>
                </form>

                <p className="auth-switch">
                  נזכרת בסיסמה?{' '}
                  <Link to="/login">התחבר</Link>
                </p>
              </>
            ) : (
              <div className="auth-confirmation">
                <div className="success-icon-large">
                  <FiCheckCircle />
                </div>
                <h1>הקישור נשלח</h1>
                <p className="auth-subtitle">
                  אם הכתובת {email} קיימת במערכת, נשלח אליה קישור לאיפוס הסיסמה.
                  בדוק את תיבת הדואר שלך (כולל תיקיית הספאם).
                </p>
                <Link to="/login" className="btn btn-primary btn-lg">
                  <FiArrowRight />
                  חזרה להתחברות
                </Link>
              </div>
            )}
          </div>
        </motion.div>

        {/* Right Side - Visual */}
        <motion.div
          className="auth-visual-section"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <div className="visual-content">
            <h2>שחזור סיסמה</h2>
            <h2 className="text-primary">בקלות ובמהירות</h2>
            <p>
              נשלח לך קישור לאיפוס הסיסמה ישירות
              לתיבת המייל שלך
            </p>
          </div>
          <div className="visual-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
